import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Input } from 'reactstrap';
import { Target, Info, CheckCircle, PlusCircle } from 'react-feather';
import { Link } from 'react-router-dom';
import { Done, All, Doing, CreateNewProject,pinagareAPIURL } from '../../../Constant';
import { Breadcrumbs, Image, P, H4, H5, H6, Btn, DRTScrumbs } from '../../../AbstractElements';
import ProjectContext from '../../../_helper/Project';
import CustomizerContext from '../../../_helper/Customizer';
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from "react-toastify";
import EmailContext from '../../../_helper/Email';
import page_icon from '../../../assets/images/drts_home/bookings_ico.png';
import { BookingsData } from './eServiceData';
import AlleServices from './AlleServices'; 



const DRTSBookings = () => { 
  const { layoutURL } = useContext(CustomizerContext);
  const [activeTab, setActiveTab] = useState('1');
  const { allData } = useContext(ProjectContext);
  const { setIsDataIn } = useContext(EmailContext);
  


  const style = {
    width: 40,
    height: 40,
  };
const style2 = { width: 60, fontSize: 14, padding: 4 };

   
const [taskData, setTaskData] = useState([]);
let newList = [...taskData];
const [pinagareItems, setPinagareItems] = useState([]);
const [pinagareTotalRows, setPinagareTotalRows] = useState(0);
const [pinagarePerPage, setPinagarePerPage] = useState(10);
const [isPrepopulatedDataIn, setIsPrepopulatedDataIn] = useState(false);
const [pinagareSupervisorTasks, setPinagareSupervisorTasks] = useState([]);



  return (
    <Fragment>
      <Breadcrumbs />
      <Container fluid={true}>

      <Row className="project-card" style={{width:"100%",textAlign:"center", padding:10, borderRadius: "0.7rem", margin:10}}>
          <Col md="12" className="project-list" style={{width:"100%",textAlign:"center", margin:0, padding:0, borderRadius: "0.7rem", backgroundColor:"#ffffff"}}>            
           
             <Row style={{textAlign:"center", padding:0, width:"100%", margin:0}}>
            
          <Col md='1' style={{textAlign:"center", width:"5%", backgroundColor:"#ffffff",padding:0, borderRadius: "0.7rem", margin:0}}>{" "}
          </Col>
          <Col md='10' style={{textAlign:"center", width:"90%", backgroundColor:"#ffffff", padding:0, borderRadius: "0.7rem", margin:0}}>			 
           
               <DRTScrumbs parent="Home" title="Bookings" mainTitle="BOOKINGS" />           
          </Col>

          <Col md='1' style={{textAlign:"center", width:"5%", backgroundColor:"#ffffff", padding:0, borderRadius: "0.7rem",margin:0}}>{" "} 
          </Col>

          </Row>    

          </Col>
        </Row>
  
		
		 <Row className="project-card">
          <Col md="12" className="project-list">
            <Card>
              <Row style={{width:"100%"}}>
                <Col md="3" style={{ width:"20%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
                
                 <Image attrImage={{ src: `${page_icon}`, 
                 alt: 'Welcome to DRTS Web Portal', width:180, 
                 border: '1px solid white', borderRadius:"1rem", textAlign: "center", margin:0, overflow: 'hidden' }} />
                           
                </Col>
				
				        <Col md="9" style={{width:"80%", backgroundColor:"#ffffff"}}>

                      
                  <Card className='schedule-card'>
                    <CardBody className='pt-0'>
                        <AlleServices data={BookingsData} /> 
                   </CardBody>
                  </Card>

                 

                </Col>
               
              </Row>
            </Card> 
          </Col>
                  
        </Row>
		
		
		
		
		
		
      </Container>
    </Fragment>
  );
};

export default DRTSBookings;